var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useMutation, useQuery, useQueryClient } from "react-query";
import { enrollmentApiRequest } from "./client";
function fetchLtiEnrollmentMap(attemptId) {
  return enrollmentApiRequest({
    url: `/lti/map?attemptId=${attemptId}`,
    method: "GET"
  });
}
function postLtiLaunch() {
  return enrollmentApiRequest({
    url: `/lti/launch`,
    method: "GET"
  });
}
function patchLtiSubmit({ attempt }) {
  return enrollmentApiRequest({
    url: `/lti/enrollment-attempt/${attempt.enrollmentAttemptId}/submit`,
    method: "PATCH"
  });
}
function patchMarkSegmentsForReview({
  action,
  attemptId,
  segmentId
}) {
  return enrollmentApiRequest({
    url: `enrollment-attempt/${attemptId}/review/${action}/${segmentId}`,
    method: "PATCH"
  });
}
function useLtiEnrollmentMapQuery({ attemptId }) {
  return useQuery(
    ["lti", "map", attemptId],
    () => fetchLtiEnrollmentMap(attemptId),
    {
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );
}
function useLtiLaunchMutation() {
  return useMutation({
    mutationFn: () => postLtiLaunch()
  });
}
function useLtiSubmitMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ attempt }) => patchLtiSubmit({ attempt }),
    onSuccess(updatedAttempt) {
      const existingLtiMap = queryClient.getQueryData([
        "lti",
        "map",
        updatedAttempt.enrollmentAttemptId
      ]);
      queryClient.setQueryData(
        ["lti", "map", updatedAttempt.enrollmentAttemptId],
        __spreadProps(__spreadValues({}, existingLtiMap), {
          attempt: updatedAttempt
        })
      );
    }
  });
}
function useMarkSegmentsForReviewMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => patchMarkSegmentsForReview(variables),
    onSuccess(updatedAttempt) {
      const existingLtiMap = queryClient.getQueryData([
        "lti",
        "map",
        updatedAttempt.enrollmentAttemptId
      ]);
      queryClient.setQueryData(
        ["lti", "map", updatedAttempt.enrollmentAttemptId],
        __spreadProps(__spreadValues({}, existingLtiMap), {
          attempt: updatedAttempt
        })
      );
    }
  });
}
export {
  useLtiEnrollmentMapQuery,
  useLtiLaunchMutation,
  useLtiSubmitMutation,
  useMarkSegmentsForReviewMutation
};
